import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { EnergyRevenuesCellChecksResponse } from "../RevenueMonitoring.types";
import { ensureListResponse } from "./ensureListResponse";

export function usePersonEnergyRevenuesVerificationItems(
  personId?: number,
  options?: Partial<UseQueryOptions<EnergyRevenuesCellChecksResponse>>
) {
  return useQuery({
    queryKey: ["energyRevenuesVerificationItems", { personId }],
    queryFn: ({ client, queryKey }) =>
      fetchEnergyRevenuesVerificationItems(
        personId,
        // Kept on screen if a refetch returns a non-array body
        client.getQueryData<EnergyRevenuesCellChecksResponse>(queryKey)
      ),
    retry: false,
    enabled: !!personId,
    ...options
  });
}

async function fetchEnergyRevenuesVerificationItems(
  personId: number | undefined,
  cachedData: EnergyRevenuesCellChecksResponse | undefined
) {
  if (!personId) return [];

  const revenueMonitoringCellChecksPerPersonUrl =
    urls.apiWithoutCamelization.revenueMonitoringCellChecks(personId);
  const response = await apiWithoutCamelization.get<unknown>(
    revenueMonitoringCellChecksPerPersonUrl
  );
  return ensureListResponse(response, "cellChecks", cachedData);
}
